$(document).ready(function () {
    var __rtl = false;

    if ($("html").attr('lang') == 'ar')
        __rtl = true;

    $(".home-trip-carousel").owlCarousel({
        nav: true,
        navText: [
            '<i class="fas fa-angle-right"></i>',
            '<i class="fas fa-angle-left"></i>',
        ],
        dots: false,
        rtl: __rtl,
        loop: true,
        lazyLoad: true,
        responsive: {
            0: {
                autoWidth: true,
                margin: 10,
            },
            992: {
                items: 3,
                margin: 10,
            }
        }
    });

    if (($(window).width()) < 768) {
        $('.posts-carousel-mobile').addClass('owl-carousel');
        var is_auto = $(".posts-carousel-mobile").data('auto');
        if (is_auto == undefined) {
            is_auto = true;
        }
        $(".posts-carousel-mobile").owlCarousel({
            items: 1,
            rtl: __rtl,
            nav: true,
            navText: [
                '<i class="fas fa-angle-right"></i>',
                '<i class="fas fa-angle-left"></i>',
            ],
            dots: false,
            margin: 15,
            smartSpeed: 450,
            loop: true,
            autoplay: is_auto,
            autoplayTimeout: 3000,
        });

        $('.blog-gallery .owl-carousel').removeClass('nav-on-side').addClass('nav-on-bottom')
    }

    $( window ).resize(function() {
        if (($(window).width()) < 768) {
            $('.posts-carousel-mobile').addClass('owl-carousel');
            var is_auto = $(".posts-carousel-mobile").data('auto');
            if (is_auto == undefined) {
                is_auto = true;
            }
            $(".posts-carousel-mobile").owlCarousel({
                items: 1,
                rtl: __rtl,
                nav: true,
                navText: [
                    '<i class="fas fa-angle-right"></i>',
                    '<i class="fas fa-angle-left"></i>',
                ],
                dots: false,
                margin: 15,
                smartSpeed: 450,
                loop: true,
                autoplay: is_auto,
                autoplayTimeout: 3000,
            });

            $('.blog-gallery .owl-carousel').removeClass('nav-on-side').addClass('nav-on-bottom')
        }else{
            $('.posts-carousel-mobile').trigger('destroy.owl.carousel');
            $('.posts-carousel-mobile').removeClass('owl-carousel');
            $('.blog-gallery .owl-carousel').addClass('nav-on-side').removeClass('nav-on-bottom')
        }
    });

    if ($(".btn-play-pause").length) {
        $(".btn-play-pause").on('click', function () {
            var owl = $(this).parent().find('.owl-carousel');
            if (owl.data('owl.carousel').settings.autoplay) {
                owl.data('owl.carousel').settings.autoplay = false;
                $(this).html('<i class="fas fa-play"></i>');
                owl.trigger('stop.owl.autoplay');
            } else {
                owl.data('owl.carousel').settings.autoplay = true;
                $(this).html('<i class="fas fa-pause"></i>');
                owl.trigger('play.owl.autoplay');
            }
        });
    }

    // Customers Carousel
    $('.customers-carousel').owlCarousel({
        loop: true,
        margin: 4,
        rtl: __rtl,
        nav: false,
        touchDrag: true,
        mouseDrag: true,
        responsive: {
            0: {
                autoWidth: true,
            },
            992: {
                items: 3,
            }
        }
    });

    $("#mapLegendsToggler").click(function () {
        $(".map-legends").toggleClass("shown");
    });
});